<template>
	<div>
		<div class="section-title is-small">
			Imprint
		</div>
		<p>
			<strong>clickfire GmbH</strong><br>
			Würzburger Straße 174<br>
			63743 Aschaffenburg<br>
			Germany<br>
			<br>
			E-Mail: support@clickfire.io<br>
			<br>
			Telefon: +49 6021 4226790<br>
			Internet: clickfire.io<br>
			<br>
			Registration court: Amtsgericht Aschaffenburg, HRB 16643<br>
			Managing director: Mira da Costa Rodrigues
		</p>
	</div>
</template>

<script>
export default {
	name: 'Imprint',
};
</script>

<style lang="scss" scoped>
h2 {
	font-size: $size-5;
	font-weight: $fontWeight-medium;
	color: $color-white;
	margin-top: $gap-2;
}

h3 {
	font-size: $size-6;
	font-weight: $fontWeight-medium;
	color: $color-white;
	margin-top: $gap-2;
}

p,
li {
	font-size: $size-7;
	font-weight: $fontWeight-regular;
	color: $color-accent-100;
	line-height: $lineHeight-medium;
	margin-top: $gap-1;
}
</style>
